<!--Links:友情链接 2021/03/25 16:47:11 YuAng-->

<template>
   <div class="its-Links">
     <ts-page-layout center>
       <div class="its-links-left">
         <div class="its-first-line">
            <link-item class="its-links-product" :item="products"></link-item>
            <link-item class="its-links-official" :item="officials"></link-item>
            <link-item class="its-links-download" :item="downloads"></link-item>
            <link-item class="its-links-company" :item="company"></link-item>
         </div>
         <div class="its-second-line">
           <link-item class="its-friend-links" :item="friendLinks">
           <div class="its-friend-links-container">
             <a v-for="(link, i) in friendLinks.urls" :key="'link-'+i" class="its-friend-link"
              :href="link.url" target="_blank">{{link.name}}</a>
           </div>
           </link-item>
           <link-item class="its-links-company its-phone" :item="phone"></link-item>
           <link-item class="its-links-company" :item="zj"></link-item>
         </div>
       </div>
       <div class="its-links-right">
         <link-item class="its-links-qr-code" :item="qrCodes">
          <div class="its-links-qrcode">
            <img src="../../../../../assets/images/edition/ekt.jpg">
            <p>学科网e课堂订阅号</p>
            <img src="../../../../../assets/images/edition/ekt_video.jpg">
            <p>学科网e课堂视频号</p>
          </div>
         </link-item>
       </div>
     </ts-page-layout>
   </div>
</template>
<script>
import LinkItem from './LinkItem'
export default {
  name: 'Links',
  components: {
    LinkItem
  },
  props: {
    type: {
      type: String,
      default: 'interact'
    }
  },
  data () {
    return {
      products: {
        title: '产品介绍',
        links: [
          {
            id: '2-1',
            name: '学校智慧教学解决方案',
            url: '/eclass/school'
          },
          {
            id: '2-2',
            name: '区域智慧教育解决方案',
            url: '/eclass/area'
          }
        ]
      },
      officials: {
        title: '官网指引',
        links: [
          {
            id: '3',
            name: '培训专区',
            url: 'http://go.plvideo.cn/album/index.html?albumId=0cbdd75d'
          },
          {
            id: '4',
            name: '示范案例',
            url: '/eclass/cases'
          },
          {
            id: '6',
            name: '关于我们',
            url: '/eclass/about'
          }
        ]
      },
      downloads: {
        title: '下载中心',
        links: [
          {
            id: '',
            name: 'e课堂教师电脑端',
            url: '/eclass/download?tab=1'
          },
          // {
          //   name: 'e课堂教师APP',
          //   url: '/eclass/download?tab=2'
          // },
          // {
          //   name: 'e课堂学生APP',
          //   url: '/eclass/download?tab=3'
          // },
          {
            name: 'e课堂家长通',
            url: '/eclass/download?tab=4'
          }
        ]
      },
      company: {
        title: '渠道合作',
        url: 'http://www.zxxk.com/qudao/',
        noLinks: true,
        links: [
          {
            name: '手机：18101357219<span>（微信同号）</span>',
          }
        ]
      },
      friendLinks: {
        title: '友情链接',
        links: [],
        urls: [
          {
            name: '学科网',
            url: 'https://www.zxxk.com/'
          },
          {
            name: '组卷网',
            url: 'https://zujuan.xkw.com/'
          },
          {
            name: 'e备课',
            url: 'https://beike.zxxk.com/'
          },
          {
            name: '视频通',
            url: 'http://www.zxxk.com/spt/'
          },
          {
            name: 'AI研修',
            url: 'http://yx.xkw.com/home/index'
          }
        ]
      },
      phone: {
        title: '客服热线',
        noLinks: true,
        links: [
          {
            name: '400-900-2556'
          }
        ]
      },
      zj: {
        title: '座机',
        noLinks: true,
        links: [
          {
            name: '010-5834 9377'
          }
        ]
      },
      qrCodes: {
        title: '关注我们',
        noLinks: true,
        links: []
      },
    }
  }
}
</script>

<style scoped>
.its-Links {
  padding: 60px 0 17px 0;
  background-color: #F1F0F0;
}

.its-links-left {
  float: left;
}

.its-links-right {
  float: right;
}

.its-links-left::after,
.its-first-line::after {
  clear: both;
  content: '';
  display: block;
}

.its-links-product {
  float: left;
  margin-right: 64px;
}

.its-links-official {
  float: left;
  margin-right: 50px;
}

.its-links-download {
  float: left;
  margin-right: 70px;
}

.its-links-company {
  float: left;
}

.its-friend-links {
  float: left;
  margin-right: 220px;
}

.its-friend-links >>> p {
  margin-bottom: 15px;
}

.its-second-line {
  margin-top: 55px;
}

.its-links-company >>> .its-link-i {
  color: black !important;
  font-size: 16px !important;
}

.its-links-company >>> .its-link-i span {
  margin-left: 32px !important;
  font-size: 16px !important;
  color: rgba(51, 51, 51, 0.6);
}

.its-friend-link {
  color: rgba(51, 51, 51, 0.6);
  font-size: 16px;
  padding: 0 10px;
  border-left: 1px solid rgba(51, 51, 51, 0.6);
  margin-top: 15px !important;
  cursor: pointer;
}

.its-friend-link:hover {
  color: #50A4F8;
}

.its-friend-link:first-child {
  border-left: none !important;
  padding-left: 0 !important;
}

.its-links-qrcode {
  text-align: left;
  margin-top: 16px;
}

.its-links-qrcode img{
  width: 100px;
  height: 100px;
}

.its-links-qrcode p {
  color: #333333;
  font-size: 16px;
  margin: 5px 0 12px 0;
}

.its-phone {
  margin-top: -125px;
}
</style>